export function resizeDefault(w, h) {
    return { rendererWidth: w, rendererHeight: h, canvasWidth: w, canvasHeight: h };
}
